// extracted by mini-css-extract-plugin
export default {"page_title":"PageLayout_page_title__Yb2QD"};